import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { InvoiceSummary } from '../../store/data/types'
import { invoicesFetch } from './InvoicesSummary'
import { InvoiceSummaryCard } from '../molecules/Invoices/InvoiceSummaryCard'
import { StyledSpinner } from './LoadablePage'
import { INVOICE_PAGE_SIZE, CX_WHATSAPP_NUMBER } from '../../common/constants'
import {
  StyledContainer,
  StyledContent,
  StyledDescription,
  StyledError,
  StyledHeader,
  StyledLink,
  StyledLogo,
  StyledTitle,
} from './styles/DeliveryPublic'
import { Helmet } from 'react-helmet'

export const DeliveryPublic = () => {
  const { merchantCode, planId } = useParams<{
    merchantCode: string
    planId: string
  }>()

  const [invoice, setInvoice] = useState<InvoiceSummary | null>(null)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchInvoice = async () => {
      try {
        setIsLoading(true)
        const data = await invoicesFetch({
          customerId: merchantCode,
          planId: planId,
          limit: INVOICE_PAGE_SIZE,
          offset: 0,
        })

        const foundInvoice = data.invoices[0]
        if (!foundInvoice) {
          setError('Entrega não encontrada')
        } else {
          setInvoice(foundInvoice)
        }
      } catch (err) {
        setError('Erro ao carregar dados da entrega')
        console.error('Error fetching invoice:', err)
      } finally {
        setIsLoading(false)
      }
    }

    fetchInvoice()
  }, [merchantCode, planId])

  if (isLoading) {
    return (
      <StyledContainer>
        <Helmet>
          <meta name="robots" content="noindex, nofollow" />
          <title>Resumo de Entrega - Clubbi</title>
        </Helmet>
        <StyledSpinner animation={'border'} role={'spinbutton'}>
          <span className="sr-only">Carregando...</span>
        </StyledSpinner>
      </StyledContainer>
    )
  }

  if (error || !invoice) {
    return (
      <StyledContainer>
        <Helmet>
          <meta name="robots" content="noindex, nofollow" />
          <title>Resumo de Entrega - Clubbi</title>
        </Helmet>
        <StyledContent>
          <StyledHeader>
            <StyledLogo src={'/img/new_clubbi.png'} alt="Logo Clubbi" />
            <StyledTitle>Resumo de Entrega</StyledTitle>
          </StyledHeader>
          <StyledError>
            {error || 'Entrega não encontrada'} <br />
            Caso precise de ajuda entre em contato{' '}
            <StyledLink
              href={`https://api.whatsapp.com/send/?phone=${CX_WHATSAPP_NUMBER}&text&type=phone_number&app_absent=0`}
              target="_blank"
              rel="noreferrer"
            >
              clicando aqui
            </StyledLink>
          </StyledError>
        </StyledContent>
      </StyledContainer>
    )
  }

  return (
    <StyledContainer>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <title>Resumo de Entrega | Clubbi</title>
      </Helmet>
      <StyledContent>
        <StyledHeader>
          <StyledLogo src={'/img/new_clubbi.png'} alt="Logo Clubbi" />
          <StyledTitle>Resumo de Entrega</StyledTitle>
          <StyledDescription>
            Aqui você encontra as informações relacionadas a sua entrega: situação, fatura,
            cobrança, nota fiscal, etc.
            <br />
            Quaisquer problemas ou mudanças necessárias, é só falar com o nosso atendimento{' '}
            <StyledLink
              href={`https://api.whatsapp.com/send/?phone=${CX_WHATSAPP_NUMBER}&text&type=phone_number&app_absent=0`}
              target="_blank"
              rel="noreferrer"
            >
              clicando aqui
            </StyledLink>
          </StyledDescription>
        </StyledHeader>
        <InvoiceSummaryCard invoice={invoice} merchantCode={merchantCode} />
      </StyledContent>
    </StyledContainer>
  )
}
